module.exports = __webpack_public_path__ + "img/pay-ali.a8693b36.png";